module.exports = __webpack_public_path__ + "img/about2.0036513b.png";